
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/home/home-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="home-view">
            <hero-section
                background-image="/images/hero/home-hero.jpg"
                headline="Sorgenfrei mit FASE2"
                subheadline="Willkommen"
                text="Ihr Facility Experte in Köln und Umgebung"
                button-text="Mehr Erfahren"
                button-link="/ueberuns/fachkompetenz"
                button-text2="Kontaktformular"
                button-link2="/home#kontakt"
                direction="center"
                height="97"
            ></hero-section>

            <benefits-section></benefits-section>

            <div class="wrapper">
                <welcome-section></welcome-section>
                <services-section></services-section>
                <contact-form></contact-form>
                <g-maps></g-maps>
            </div>

            <cta-section
                background-image="/images/cta-bg.webp"
                headline="FASE2 - Innovation, Vertrauen und Professionalität auf höchstem Niveau."
                subheadline="Ihr Facility Experte in Köln und Umgebung"
                text="Lassen Sie uns gemeinsam Ihre Immobilie auf das nächste Level heben!"
                button-text2="Jetzt Kontakt aufnehmen"
                button-link2="/home#kontakt"
            ></cta-section>

            <!--<testimonials-section></testimonials-section>-->
            <g-reviews></g-reviews>
    </section>`,
      style: `home-view .home-view {
  margin: 0;
  padding: 0;
}
home-view .home-view > .wrapper {
  max-width: 1568px;
  padding: 0 64px 96px 64px;
}
home-view .home-view > .wrapper article {
  margin: 0 0 64px 0;
  padding: 0;
}
home-view .home-view > .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  home-view .home-view .wrapper {
    padding: 0 32px 64px 32px;
  }
}
@media (max-width: 759px) {
  home-view .home-view .wrapper {
    padding: 0 32px 0 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  